import * as Yup from 'yup';

export const orderNumberValidationSchema = Yup.object().shape({
  orderNumber: Yup.string()
    .matches(/^\d{9}$/, 'Номер заказа состоит из 9 цифр')
    .required('Необходимо ввести номер'),
});
